import { useMemo } from 'react';
import { AudioType } from 'dorian-shared/types/audio/audio';
import { AudioStepAction } from 'dorian-shared/types/audio/AudioStepSettingsType';
import { BranchStep } from 'dorian-shared/types/branch/BranchStep';

interface AudioState {
  isPlaying: boolean;
  isLooping: boolean;
}

/**
 * Custom hook to detect if node has looping audio at the end of node
 * @param steps - Array of steps containing audio information
 * @returns Whether the node has looping audio
 */
export const useLoopingAudioDetection = (steps: BranchStep[]): boolean => useMemo(() => {
  if (!steps?.length) return false;

  return steps.some(
    (step) => step.stepAudios?.some((audio) => audio.type === AudioType.Music
    && audio.audioSettings?.loop),
  );
}, [steps]);
